import {
	Mandarin,
	ParadisePink,
	PurpleNavy,
	PersianGreen,
	CottonCandy,
	DeepJungle,
	CedarChest,
	YellowOrange,
	RedSalsa,
	CopperCrayola,
	OrangeYellowCrayola,
	Emerald,
	OrchidCrayola,
	Sunray,
	UltramarineBlue,
	Verdigris,
	OldGold,
	AquaMarine,
	RazzmicBerry,
} from './baseTheme';

export default [
	UltramarineBlue,
	OldGold,
	ParadisePink,
	CedarChest,
	AquaMarine,
	Mandarin,
	Verdigris,
	YellowOrange,
	CottonCandy,
	Emerald,
	OrangeYellowCrayola,
	PurpleNavy,
	DeepJungle,
	RedSalsa,
	OrchidCrayola,
	CopperCrayola,
	RazzmicBerry,
	PersianGreen,
	Sunray,
];
